import { withJsonFormsControlProps } from "@jsonforms/react";
import { CustomRendererProps } from "../types";
import { SchemaData } from "layouts/aplicacoes/Events/hooks/types";
import { AttendanceManagement } from "layouts/aplicacoes/Events/components/AttendanceManagement";

function EventAttendanceManagement({ data }: CustomRendererProps<SchemaData>) {
  if (!data?.id) return null;
  return <AttendanceManagement eventId={Number(data.id)} />;
}

export default withJsonFormsControlProps(EventAttendanceManagement);
